import { motion } from 'framer-motion'
import styled, { css } from 'styled-components'

export const FullWidthAnimateHeight = styled(motion.div)<{
  $isExpanded?: boolean
  $hasFading?: boolean
}>`
  position: relative;
  width: 100%;
  overflow: hidden;

  ${({ $hasFading, $isExpanded }) => {
    return (
      $hasFading &&
      css`
        &:after {
          content: '';
          display: ${$isExpanded ? 'none' : 'block'};
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 50px;
          background: linear-gradient(
            0deg,
            ${({ theme }) => theme.colors.boxBackground} 0%,
            rgba(255, 255, 255, 0) 100%
          );
        }
      `
    )
  }}
`
